import { yupResolver } from "@hookform/resolvers/yup";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FormProvider, useController, useForm } from "react-hook-form";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import * as yup from "yup";
import Input from "../../../../components/Common/Input/Input";
import { publishSchema } from "../../../../utils/mainTabs/manage/createShotclassSchema";
import TelevisionImage from "../../../../assets/images/Manage/Television.png";
import MobileImage from "../../../../assets/images/Manage/Mobile.png";
import Button from "../../../../components/Common/Button/Button";
import PlayIcon from "../../../../components/Common/SvgIcons/ManageIcons/PlayIcon";
import InfromationSmallIcon from "../../../../components/Common/SvgIcons/CommonIcons/InfromationSmallIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  copyShotclassActionHandler,
  createShotclassActionHandler,
  getUserGroupsActionHandler,
  updateShotclassActionHandler,
} from "../../../../store/actions/actionHandlers/manageActionHandler";
import Modal from "../../../../components/Common/Modal/Modal";
import PreviousIcon from "../../../../components/Common/SvgIcons/CommonIcons/PreviousIcon";
import { contentMediaTypes } from "../../../../utils/contentMediaTypes";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import loaders from "../../../../store/actions/actionCreators/loadersActionCreator";
import Tooltip from "../../../../components/Common/ToolTip/Tooltip";
import classes from "./Publish.module.scss";
import { submisssions } from "../../../../utils/mainTabs/social/submissions";
import { setShotClassFormData } from "../../../../store/actions/actionCreators/socialActionCreator";
import DocumentContent from "../../../../components/Manage/ViewContent/DocumentContent/DocumentContent";
import VideoContent from "../../../../components/Manage/ViewContent/VideoContent/VideoContent";
import { MdCancel } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { isShortclassNameExistsActionHandler } from "../../../../store/actions/actionHandlers/socialActionHandler";
import { moderateContributions } from "../../../../utils/mainTabs/social/moderateContributions";
import ShotclassCourseFinished from "./ShotclassCourseFinished";
// import { usePrompt } from "../../../../hooks/preventNavigationHook";

// Validation schema for completion screen
const completionScreenSchema = yup.object().shape({
  completionTitle: yup
    .string()
    .required("Completion title is required")
    .trim()
    .min(1, "Title cannot be empty"),
  completionMessage: yup
    .string()
    .required("Completion message is required")
    .trim()
    .min(1, "Message cannot be empty"),
});

const Publish = () => {
  var reader = new FileReader();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const { tenantName } = useOutletContext();
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;

  const [formData, setFormData] = useState([]);
  const [isPlay, setIsPlay] = useState(false);
  const [userGroups, setUserGroups] = useState([]);
  const [noContentModal, setNoContentModal] = useState(false);
  const [previewHover, setPreviewHover] = useState(false);
  const [normalExit, setNormalExit] = useState(false);

  // Course completion screen customization states
  const [isCompletionScreenModal, setIsCompletionScreenModal] = useState(false);
  const [completionScreenData, setCompletionScreenData] = useState({
    completionTitle: "",
    completionMessage: "",
  });
  const [isCustomCompletionEnabled, setIsCustomCompletionEnabled] =
    useState(false);
  const [showViewLink, setShowViewLink] = useState(false);

  const {
    formValues,
    manageTiles,
    setFormValues,
    shotclassType,
    managePath,
    createShotclassesPath,
    createShotclassesEditPath,
    createShotclassesCopyPath,
    shotclassTypeFrom,
    MSOMFeaturesInShotclass,
    isWebinarSelected,
  } = useOutletContext();
  const manageState = useSelector((state) => state.manageReducer);
  const { saveAsADraftLoader, shotclassPublishLoader, getUserGroupsLoader } =
    manageState;

  let buttonTexts = useMemo(() => {
    return {
      addDetails: "Add Details",
      addQuiz: "Add Quiz",
      addSurvey: "Add Survey",
    };
  }, []);
  const [submitButtonText, setSubmitButtonText] = useState(
    buttonTexts.addSurvey,
  );

  // Separate form for completion screen modal
  const completionScreenForm = useForm({
    defaultValues: {
      completionTitle: "",
      completionMessage: "",
    },
    resolver: yupResolver(completionScreenSchema),
  });

  const {
    handleSubmit: handleCompletionSubmit,
    control: completionControl,
    reset: resetCompletionForm,
    watch: completionWatch,
    register: completionRegister,
    formState: { isValid: isCompletionValid, errors: completionErrors },
  } = completionScreenForm;

  // Memoize completion screen default values (without calling watch)
  const completionDefaults = useMemo(
    () => ({
      title:
        formValues?.publish?.completionConfiguration?.completionTitle ||
        "Congratulations!",
      message:
        formValues?.publish?.completionConfiguration?.completionMessage ||
        "Successfully Finished Course",
    }),
    [formValues?.publish?.completionConfiguration],
  );

  // Initialize completion screen customization based on existing data
  useEffect(() => {
    // Handle existing completion configuration from API/form data
    if (
      formValues?.publish?.isCustomCompletionEnabled &&
      formValues?.publish?.completionConfiguration
    ) {
      const existingConfig = formValues.publish.completionConfiguration;

      setIsCustomCompletionEnabled(true);
      setShowViewLink(true);

      // Update local state with actual data from API/form
      setCompletionScreenData({
        completionTitle: existingConfig.completionTitle || "",
        completionMessage: existingConfig.completionMessage || "",
      });

      // Reset the modal form with existing values
      resetCompletionForm({
        completionTitle: existingConfig.completionTitle || "",
        completionMessage: existingConfig.completionMessage || "",
      });
    } else {
      // For new shotclass or when not enabled, start with clean state
      setIsCustomCompletionEnabled(
        formValues?.publish?.isCustomCompletionEnabled === true,
      );
      setShowViewLink(
        formValues?.publish?.isCustomCompletionEnabled === true &&
          !!formValues?.publish?.completionConfiguration,
      );

      // Reset to empty form if no configuration exists
      setCompletionScreenData({
        completionTitle: "",
        completionMessage: "",
      });
      resetCompletionForm({
        completionTitle: "",
        completionMessage: "",
      });
    }
  }, [
    formValues?.publish?.isCustomCompletionEnabled,
    formValues?.publish?.completionConfiguration,
    resetCompletionForm,
  ]);

  useEffect(() => {
    if (formValues?.Other?.IsDistributed) {
      if (formValues?.Other?.ShotClassType === 1) {
        if (formValues?.Other?.PublishedbyMe)
          setSubmitButtonText(buttonTexts.addDetails);
        else setSubmitButtonText(buttonTexts.addQuiz);
      } else if (
        formValues?.Other?.ShotClassType === 2 ||
        formValues?.Other?.ShotClassType === 6
      ) {
        setSubmitButtonText(buttonTexts.addQuiz);
      } else if (
        formValues?.Other?.ShotClassType === 3 ||
        formValues?.Other?.ShotClassType === 4 ||
        formValues?.Other?.ShotClassType === 5 ||
        formValues?.Other?.ShotClassType === 7
      ) {
        setSubmitButtonText(buttonTexts.addSurvey);
      }
      // if (formValues?.addSurvey?.TotalQuestionCount > 0) {
      //   setSubmitButtonText(buttonTexts.addSurvey);
      // } else if (
      //   formValues?.addSurvey?.TotalQuestionCount === 0 &&
      //   formValues?.addQuiz?.TotalQuestionCount > 0
      // ) {
      //   setSubmitButtonText(buttonTexts.addQuiz);
      // } else if (
      //   formValues?.addQuiz?.TotalQuestionCount === 0 &&
      //   formValues?.addSurvey?.TotalQuestionCount === 0
      // ) {
      //   setSubmitButtonText(buttonTexts.addDetails);
      // }
    }
    if (formValues?.details?.Content?.ContentMediaType === 8) {
      setSubmitButtonText(buttonTexts.addDetails);
    }
    if (shotclassType == "view" && formValues?.Other?.IsDistributed) {
      setSubmitButtonText(buttonTexts.addDetails);
    }
  }, [
    buttonTexts,
    formValues?.Other?.IsDistributed,
    formValues?.addQuiz?.TotalQuestionCount,
    formValues?.addSurvey?.TotalQuestionCount,
    formValues?.details?.Content?.ContentMediaType,
    formValues?.Other?.ShotClassType,
  ]);

  const methods = useForm({
    defaultValues: {
      ...formValues.publish,
      // ✅ Set IsTrackingEnabled to true by default for scored surveys (both new and existing)
      IsTrackingEnabled: (() => {
        const isScoredSurvey =
          formValues?.addSurvey?.surveyType === "scored" &&
          formValues?.addSurvey?.TotalQuestionCount > 0;

        if (isScoredSurvey) {
          return formValues.publish.IsTrackingEnabled ?? true;
        }

        return formValues.publish.IsTrackingEnabled ?? false;
      })(),
      // ✅ Use existing completion configuration from form data (no defaults)
      isCustomCompletionEnabled:
        formValues?.publish?.isCustomCompletionEnabled ?? false,
      completionConfiguration:
        formValues?.publish?.completionConfiguration || null,
    },
    resolver: yupResolver(publishSchema),
  });
  const {
    handleSubmit,
    control,
    watch,
    getValues,
    reset,
    setValue,
    formState: { errors, isValid, isDirty },
  } = methods;
  const { field: PreviewField } = useController({ name: "Preview", control });

  // let selectedValues = watch([
  //   "OfflineShotclass",
  //   "IsVideoMandatory",
  //   "QuestionJumbling",
  //   "ShowCorrectAnswers",
  //   "CanChangeAnswers",
  //   "IsSurveyMandatory",
  //   "HasRestricted",
  // ]);
  const offlineShotclass = watch("OfflineShotclass");
  const isVideoMandatory = watch("IsVideoMandatory");
  const questionJumbling = watch("QuestionJumbling");
  const showCorrectAnswers = watch("ShowCorrectAnswers");
  const canChangeAnswers = watch("CanChangeAnswers");
  const isSurveyMandatory = watch("IsSurveyMandatory");
  const hasRestricted = watch("HasRestricted");
  const isTrackingEnabled = watch("IsTrackingEnabled");

  let setUpdatedUserGroups = useCallback(
    (userGroups) => {
      let selectedTags = formValues.publish.ShotclassTargetGroupMapping;
      if (
        // (location.pathname.includes(createShotclassesEditPath) ||
        //   location.pathname.includes(createShotclassesCopyPath)) &&
        selectedTags?.length > 0
      ) {
        // let updatedTagsList = [];
        let updatedUserGroup = userGroups.map((userGroup) => {
          let updatedUserGroup = userGroup;
          selectedTags.forEach((tag) => {
            if (userGroup.UserGroupId === tag.UserGroupId) {
              // updatedTagsList.push({ ...tag, TagName: userGroup.Name });
              updatedUserGroup = { ...userGroup, checked: true };
            }
          });
          return { ...updatedUserGroup, isVisible: true };
        });
        setUserGroups(updatedUserGroup);
        // setFormValues((formValues) => {
        //   return {
        //     ...formValues,
        //     publish: { ...formValues.publish, TagsList: updatedTagsList },
        //   };
        // });
      } else {
        let updatedUserGroup = userGroups.map((userGroup) => {
          return { ...userGroup, isVisible: true };
        });
        setUserGroups(updatedUserGroup);
      }
    },
    [
      // location.pathname,
      // createShotclassesEditPath,
      // createShotclassesCopyPath,
      formValues.publish.ShotclassTargetGroupMapping,
    ],
  );

  useEffect(() => {
    dispatch(getUserGroupsActionHandler()).then((data) => {
      setUpdatedUserGroups(data);
    });
  }, [dispatch, setUpdatedUserGroups]);

  useEffect(() => {
    manageTiles?.forEach((tile) => {
      if (location.pathname === tile.path) {
        let formArgs = {
          formValues,
          offlineShotclass,
          isVideoMandatory,
          questionJumbling,
          showCorrectAnswers,
          canChangeAnswers,
          isSurveyMandatory,
          hasRestricted,
          userGroups,
          setUserGroups,
          getUserGroupsLoader,
          isTrackingEnabled,
        };
        let data = tile.formData(formArgs);

        if (!MSOMFeaturesInShotclass.Offline) {
          const updatedData = data?.filter(
            (field) => field.name !== "OfflineShotclass",
          );
          setFormData(updatedData);
        } else {
          setFormData(data);
        }
      }
    });
  }, [
    location,
    manageTiles,
    offlineShotclass,
    isVideoMandatory,
    questionJumbling,
    showCorrectAnswers,
    canChangeAnswers,
    isSurveyMandatory,
    hasRestricted,
    formValues,
    userGroups,
    getUserGroupsLoader,
    isTrackingEnabled,
  ]);

  // Handler functions for completion screen customization
  const handleCompletionScreenCheckbox = (checked) => {
    setIsCustomCompletionEnabled(checked);
    if (checked) {
      // When enabling, open modal with current data (if any)
      setIsCompletionScreenModal(true);
    } else {
      // When disabling, clear everything
      setShowViewLink(false);
      setCompletionScreenData({
        completionTitle: "",
        completionMessage: "",
      });
      resetCompletionForm({
        completionTitle: "",
        completionMessage: "",
      });
      // Remove completion configuration from form data
      setFormValues((formValues) => {
        return {
          ...formValues,
          publish: {
            ...formValues?.publish,
            isCustomCompletionEnabled: false,
            completionConfiguration: null,
          },
        };
      });
    }
  };

  const handleSaveCompletionScreen = (data) => {
    // Update state data
    setCompletionScreenData({
      completionTitle: data.completionTitle,
      completionMessage: data.completionMessage,
    });

    // Update form data
    setFormValues((formValues) => {
      return {
        ...formValues,
        publish: {
          ...formValues?.publish,
          isCustomCompletionEnabled: true,
          completionConfiguration: {
            completionTitle: data.completionTitle,
            completionMessage: data.completionMessage,
          },
        },
      };
    });

    setShowViewLink(true);
    setIsCompletionScreenModal(false);
  };

  const handleViewCompletionScreen = () => {
    // Reset form with current data when opening for viewing/editing
    resetCompletionForm({
      completionTitle: completionScreenData.completionTitle,
      completionMessage: completionScreenData.completionMessage,
    });
    setIsCompletionScreenModal(true);
  };

  const handleCloseCompletionScreenModal = () => {
    setIsCompletionScreenModal(false);
    if (!showViewLink) {
      setIsCustomCompletionEnabled(false);
    }
  };

  const handleBack = () => {
    let publishData = getValues();
    setFormValues((formValues) => {
      return {
        ...formValues,
        publish: {
          ...formValues?.publish,
          ...publishData,
          // Preserve completion screen state based on checkbox status
          isCustomCompletionEnabled: isCustomCompletionEnabled,
          completionConfiguration: isCustomCompletionEnabled
            ? formValues?.publish?.completionConfiguration
            : null,
        },
      };
    });
    // If webinar is selected, always go back to details page
    if (isWebinarSelected) {
      if (
        location?.pathname?.includes(
          `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`,
        ) ||
        location?.pathname?.includes(
          `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`,
        )
      ) {
        navigate(
          `${submisssions.shotClassespath(
            params,
            location,
            tenantName,
          )}/details`,
        );
      } else {
        navigate(`${createShotclassesPath}/details`);
      }
      return; // Exit early to prevent other navigation logic
    }
    if (submitButtonText === buttonTexts.addSurvey) {
      if (
        location?.pathname?.includes(
          `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`,
        ) ||
        location?.pathname?.includes(
          `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`,
        )
      )
        navigate(
          `${submisssions.shotClassespath(
            params,
            location,
            tenantName,
          )}/addSurvey`,
        );
      else navigate(`${createShotclassesPath}/addSurvey`);
    } else if (submitButtonText === buttonTexts.addQuiz) {
      if (
        location?.pathname?.includes(
          `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`,
        ) ||
        location?.pathname?.includes(
          `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`,
        )
      )
        navigate(
          `${submisssions.shotClassespath(
            params,
            location,
            tenantName,
          )}/addQuiz`,
        );
      else navigate(`${createShotclassesPath}/addQuiz`);
    } else if (submitButtonText === buttonTexts.addDetails) {
      if (
        location?.pathname?.includes(
          `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`,
        ) ||
        location?.pathname?.includes(
          `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`,
        )
      )
        navigate(
          `${submisssions.shotClassespath(
            params,
            location,
            tenantName,
          )}/details`,
        );
      else navigate(`${createShotclassesPath}/details`);
    }
  };

  const submitData = (shotclassData) => {
    if (
      location?.pathname?.includes(
        `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`,
      )
    ) {
      const contentVal = {
        ...shotclassData,
        details: {
          ...shotclassData?.details,
          Content: {
            ...shotclassData?.details?.Content,
            ContentValue: [
              {
                link: shotclassData?.details?.Content?.ContentValue,
              },
            ],
          },
        },
      };
      const updatedShotclassData =
        typeof shotclassData?.details?.Content?.ContentValue === "string" &&
        shotclassData?.details?.Content?.ContentMediaType === 2
          ? contentVal
          : shotclassData;
      dispatch(loaders.manage.createShotclasses.shotclassPublishLoader(true));
      dispatch(
        isShortclassNameExistsActionHandler(
          shotclassData?.details?.ShotClassName,
        ),
      )
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              dispatch(
                loaders.manage.createShotclasses.shotclassPublishLoader(false),
              );
              dispatch(
                setErrorHandler(
                  errorTypes.FAIL,
                  `Class Name is already exist.`,
                ),
              );
            } else
              dispatch(createShotclassActionHandler(updatedShotclassData)).then(
                (isSaved) => {
                  if (isSaved) {
                    dispatch(
                      setErrorHandler(
                        errorTypes.SUCCESS,
                        `Your Shotclass ${shotclassData?.details?.ShotClassName} is published. You can view same in Distribute Shotclass and/or My Published Classes`,
                      ),
                    );
                    navigate(submisssions.path(tenantName));
                  }
                },
              );
          }
        })
        .finally(() => {
          dispatch(
            loaders.manage.createShotclasses.shotclassPublishLoader(false),
          );
        });
    } else {
      if (shotclassType === "copy") {
        dispatch(copyShotclassActionHandler(shotclassData))
          .then((isSaved) => {
            if (isSaved) {
              if (isSaved !== "video") {
                dispatch(
                  setErrorHandler(
                    errorTypes.SUCCESS,
                    `Your Shotclass ${shotclassData?.details?.ShotClassName} is published. You can view same in Distribute Shotclass and/or My Published Classes`,
                  ),
                );
              }
              dispatch(
                loaders.manage.createShotclasses.shotclassPublishLoader(false),
              );
              navigate(managePath);
            }
          })
          .finally(() => {
            dispatch(
              loaders.manage.createShotclasses.shotclassPublishLoader(false),
            );
          });
      } else if (shotclassType === "edit") {
        dispatch(updateShotclassActionHandler(shotclassData))
          .then((isSaved) => {
            if (isSaved) {
              if (isSaved !== "video") {
                dispatch(
                  setErrorHandler(
                    errorTypes.SUCCESS,
                    `Your Shotclass ${shotclassData?.details?.ShotClassName} is published. You can view same in Distribute Shotclass and/or My Published Classes`,
                  ),
                );
              }
              dispatch(
                loaders.manage.createShotclasses.shotclassPublishLoader(false),
              );
              navigate(managePath);
            }
          })
          .finally(() => {
            dispatch(
              loaders.manage.createShotclasses.shotclassPublishLoader(false),
            );
          });
      } else {
        dispatch(createShotclassActionHandler(shotclassData))
          .then((isSaved) => {
            if (isSaved) {
              if (isSaved !== "video") {
                dispatch(
                  setErrorHandler(
                    errorTypes.SUCCESS,
                    `Your Shotclass ${shotclassData?.details?.ShotClassName} is published. You can view same in Distribute Shotclass and/or My Published Classes`,
                  ),
                );
              }
              dispatch(
                loaders.manage.createShotclasses.shotclassPublishLoader(false),
              );
              navigate(managePath);
            }
          })
          .finally(() => {
            dispatch(
              loaders.manage.createShotclasses.shotclassPublishLoader(false),
            );
          });
      }
    }
  };

  const handleSaveAsDraft = () => {
    dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(true));
    let shotclassData = { ...formValues, publish: getValues() };
    if (shotclassType === "edit") {
      dispatch(updateShotclassActionHandler(shotclassData, "Saved"))
        .then((isSaved) => {
          if (isSaved) {
            if (isSaved !== "video") {
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  `Your Shotclass ${shotclassData?.details?.ShotClassName} is saved successfully`,
                ),
              );
            }
            dispatch(
              loaders.manage.createShotclasses.saveAsADraftLoader(false),
            );
            navigate(managePath);
          }
        })
        .finally(() => {
          dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(false));
        });
    } else if (shotclassType === "copy") {
      dispatch(copyShotclassActionHandler(shotclassData, "Saved"))
        .then((isSaved) => {
          if (isSaved) {
            if (isSaved !== "video") {
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  `Your Shotclass ${shotclassData?.details?.ShotClassName} is saved successfully`,
                ),
              );
            }
            dispatch(
              loaders.manage.createShotclasses.saveAsADraftLoader(false),
            );
            navigate(managePath);
          }
        })
        .finally(() => {
          dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(false));
        });
    } else {
      dispatch(
        createShotclassActionHandler(
          shotclassData,
          "Saved",
          "LearningContentWithQuizAndSurvey",
        ),
      )
        .then((isSaved) => {
          if (isSaved) {
            if (isSaved !== "video") {
              dispatch(
                setErrorHandler(
                  errorTypes.SUCCESS,
                  `Your Shotclass ${shotclassData?.details?.ShotClassName} is saved successfully`,
                ),
              );
            }
            dispatch(
              loaders.manage.createShotclasses.saveAsADraftLoader(false),
            );
            navigate(managePath);
          }
        })
        .finally(() => {
          dispatch(loaders.manage.createShotclasses.saveAsADraftLoader(false));
        });
    }
  };
  useEffect(() => {
    if (shotclassType !== "create") {
      setValue("IsSurveyMandatory", formValues?.publish?.IsSurveyMandatory);

      // ✅ Synchronize completion configuration values for edit/copy operations
      setValue(
        "isCustomCompletionEnabled",
        formValues?.publish?.isCustomCompletionEnabled ?? false,
      );
      if (formValues?.publish?.completionConfiguration) {
        setValue(
          "completionConfiguration",
          formValues.publish.completionConfiguration,
        );
      }

      // ✅ For existing scored surveys, use saved value or default to true
      const isExistingScoredSurvey =
        formValues?.addSurvey?.surveyType === "scored" &&
        formValues?.addSurvey?.TotalQuestionCount > 0;

      if (isExistingScoredSurvey) {
        setValue(
          "IsTrackingEnabled",
          formValues?.publish?.IsTrackingEnabled ?? true,
        );
      } else {
        setValue("IsTrackingEnabled", formValues?.publish?.IsTrackingEnabled);
      }
    } else {
      // ✅ For new scored surveys, ensure IsTrackingEnabled defaults to true
      const isScoredSurvey =
        formValues?.addSurvey?.surveyType === "scored" &&
        formValues?.addSurvey?.TotalQuestionCount > 0;

      if (
        isScoredSurvey &&
        formValues?.publish?.IsTrackingEnabled === undefined
      ) {
        setValue("IsTrackingEnabled", true);
      }

      // ✅ Only set completion configuration if it exists (no defaults for new shotclasses)
      setValue(
        "isCustomCompletionEnabled",
        formValues?.publish?.isCustomCompletionEnabled ?? false,
      );
      if (formValues?.publish?.completionConfiguration) {
        setValue(
          "completionConfiguration",
          formValues.publish.completionConfiguration,
        );
      }
    }
  }, [formValues, shotclassType, location?.pathname, setValue]);

  const onSubmit = (data) => {
    let learningContentOnly =
      formValues?.details?.Content?.ContentValue &&
      formValues?.addQuiz?.TotalQuestionCount > 0 &&
      formValues?.addSurvey?.TotalQuestionCount > 0
        ? "LearningContentWithQuizAndSurvey"
        : !formValues?.details?.Content?.ContentValue &&
            formValues?.addQuiz?.TotalQuestionCount > 0 &&
            formValues?.addSurvey?.TotalQuestionCount > 0
          ? "QuizAndSurveyOnly"
          : formValues?.details?.Content?.ContentValue &&
              formValues?.addQuiz?.TotalQuestionCount > 0
            ? "LearningContentAndQuiz"
            : formValues?.details?.Content?.ContentValue &&
                formValues?.addSurvey?.TotalQuestionCount > 0
              ? "LearningContentAndSurvey"
              : formValues?.details?.Content?.ContentValue
                ? "LearningContentOnly"
                : formValues?.addQuiz?.TotalQuestionCount > 0
                  ? "QuizOnly"
                  : formValues?.addSurvey?.TotalQuestionCount > 0
                    ? "SurveyOnly"
                    : "";
    let shotclassData = {
      ...formValues,
      publish: {
        ...data,
        LearningContentOnly: learningContentOnly,
        // Include completion configuration if it exists
        ...(formValues?.publish?.isCustomCompletionEnabled &&
          formValues?.publish?.completionConfiguration && {
            isCustomCompletionEnabled:
              formValues.publish.isCustomCompletionEnabled,
            completionConfiguration: formValues.publish.completionConfiguration,
          }),
      },
    };
    if (
      !formValues?.details?.Content?.ContentValue &&
      !formValues?.addSurvey?.TotalQuestionCount > 0 &&
      !formValues?.addQuiz?.TotalQuestionCount &&
      !location?.pathname?.includes(
        `${moderateContributions?.path(tenantName)}`,
      )
    ) {
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          `A Shotclass should contain at least one component among Content, Quiz and Survey`,
        ),
      );
    } else if (formValues?.details?.Content?.ContentValue) {
      submitData(shotclassData);
    } else {
      setFormValues((formValues) => {
        return {
          ...formValues,
          publish: {
            ...data,
            LearningContentOnly: learningContentOnly,
            // Include completion configuration if it exists
            ...(formValues?.publish?.isCustomCompletionEnabled &&
              formValues?.publish?.completionConfiguration && {
                isCustomCompletionEnabled:
                  formValues.publish.isCustomCompletionEnabled,
                completionConfiguration:
                  formValues.publish.completionConfiguration,
              }),
          },
        };
      });
      setNoContentModal(!noContentModal);
    }

    if (
      location?.pathname?.includes(
        `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`,
      ) ||
      location?.pathname?.includes(
        `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`,
      )
    ) {
      dispatch(
        setShotClassFormData({
          ...formValues,
          publish: {
            ...data,
            LearningContentOnly: learningContentOnly,
            // Include completion configuration if it exists
            ...(formValues?.publish?.isCustomCompletionEnabled &&
              formValues?.publish?.completionConfiguration && {
                isCustomCompletionEnabled:
                  formValues.publish.isCustomCompletionEnabled,
                completionConfiguration:
                  formValues.publish.completionConfiguration,
              }),
          },
        }),
      );
    }
  };

  const handlePlayContent = () => {
    setIsPlay(true);
    setPreviewHover(false);
  };

  const handleClosePlayContainer = () => {
    setIsPlay(false);
    setPreviewHover(true);
  };
  // useEffect(() => {
  //   if (isDirty) setNormalExit(true);
  // }, [setNormalExit, isDirty]);

  // usePrompt("Are you sure you want to leave this page?", normalExit);

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className={classes.publish__form}>
        <div className={classes.publish__form__main}>
          <div className={classes.publish__form__main__left}>
            <div className={classes.publish__form__main__left__selectPreview}>
              <FormattedMessage id="P_REVIEW" />
              <div
                className={
                  classes.publish__form__main__left__selectPreview__radioButton
                }
              >
                <Input
                  label={"Desktop"}
                  fieldName={"Desktop"}
                  name="Preview"
                  type="radio"
                  width="2"
                  height="2"
                  value={"Desktop"}
                  direction={"row-reverse"}
                  disableLabelClick
                />
                <Input
                  label={"Mobile"}
                  fieldName={"Mobile"}
                  name="Preview"
                  type="radio"
                  width="2"
                  height="2"
                  value={"Mobile"}
                  direction={"row-reverse"}
                  disableLabelClick
                />
              </div>
            </div>
            <div
              className={classes.publish__form__main__left__preview}
              style={{
                height: PreviewField?.value === "Desktop" ? "31rem" : "30.5rem",
                width: PreviewField?.value === "Desktop" ? "42rem" : "15.4rem",
              }}
              onMouseEnter={() => {
                !isPlay && setPreviewHover(true);
              }}
              onMouseLeave={() => setPreviewHover(false)}
            >
              <div
                className={classes.publish__form__main__left__preview__bgImage}
                style={{
                  top: PreviewField?.value === "Desktop" ? "4.3%" : "6.5%",
                  height: PreviewField?.value === "Desktop" ? "64%" : "88%",
                  width: PreviewField?.value === "Desktop" ? "76.5%" : "87%",
                  backgroundImage: `url("${
                    typeof formValues.details.ThumbnailImage === "string"
                      ? formValues.details.ThumbnailImage
                      : formValues.details.ThumbnailImage.MediaUri
                  }")
  `,
                }}
              ></div>
              <img
                src={
                  PreviewField?.value === "Desktop"
                    ? TelevisionImage
                    : MobileImage
                }
                alt="preview"
                className={classes.publish__form__main__left__preview__image}
              />
              {isPlay ? (
                <div
                  className={
                    PreviewField?.value === "Desktop"
                      ? classes.publish__form__main__left__preview__image__desktopPlayContainer
                      : classes.publish__form__main__left__preview__image__mobilePlayContainer
                  }
                >
                  <div
                    className={
                      PreviewField?.value === "Desktop"
                        ? classes.publish__form__main__left__preview__image__desktopPlayContainer__closeIcon
                        : classes.publish__form__main__left__preview__image__mobilePlayContainer__closeIcon
                    }
                    onClick={() => handleClosePlayContainer()}
                  >
                    <MdCancel />
                  </div>
                  {formValues?.details?.Content?.ContentMediaType === 2 ? (
                    <DocumentContent
                      shotclassData={{
                        VideoUrl:
                          formValues.Other?.VideoUrl ===
                          formValues.details.Content.ContentValue
                            ? formValues.Other?.VideoUrl
                            : formValues?.details?.Content?.ContentValue[0]
                                ?.link,
                        Name: formValues?.details?.Content?.ContentValue[0]
                          ?.name,
                        Mediatype:
                          formValues?.details?.Content?.ContentMediaType,
                      }}
                    />
                  ) : formValues?.details?.Content?.ContentMediaType === 1 &&
                    formValues?.details?.Content?.ContentValue[0]?.type ===
                      "video/mp4" ? (
                    <VideoContent
                      shotclassData={{
                        VideoUrl:
                          formValues.Other?.VideoUrl ===
                          formValues.details.Content.ContentValue
                            ? formValues.Other?.VideoUrl
                            : URL.createObjectURL(
                                formValues?.details?.Content?.ContentValue?.[0],
                              ),
                        type: formValues?.details?.Content?.ContentValue[0]
                          ?.type,
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              ) : previewHover ? (
                <div
                  className={
                    PreviewField?.value === "Desktop"
                      ? classes.publish__form__main__left__preview__image__desktopHoverDetails
                      : classes.publish__form__main__left__preview__image__mobileHoverDetails
                  }
                >
                  <div
                    className={
                      PreviewField?.value === "Desktop"
                        ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container
                        : classes.publish__form__main__left__preview__image__mobileHoverDetails__container
                    }
                  >
                    <div
                      className={
                        PreviewField?.value === "Desktop"
                          ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container__title
                          : classes.publish__form__main__left__preview__image__mobileHoverDetails__container__title
                      }
                    >
                      Course Title :
                    </div>
                    <div
                      className={
                        PreviewField?.value === "Desktop"
                          ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container__courseTitle
                          : classes.publish__form__main__left__preview__image__mobileHoverDetails__container__courseTitle
                      }
                    >
                      {formValues?.details?.ShotClassName}
                    </div>
                  </div>
                  <div
                    className={
                      PreviewField?.value === "Desktop"
                        ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container
                        : classes.publish__form__main__left__preview__image__mobileHoverDetails__container
                    }
                  >
                    <div
                      className={
                        PreviewField?.value === "Desktop"
                          ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container__title
                          : classes.publish__form__main__left__preview__image__mobileHoverDetails__container__title
                      }
                    >
                      <FormattedMessage id="DESCRIPTION_TEXT" /> :
                    </div>
                    <div
                      className={
                        PreviewField?.value === "Desktop"
                          ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container__courseDescription
                          : classes.publish__form__main__left__preview__image__mobileHoverDetails__container__courseDescription
                      }
                    >
                      {formValues?.details?.Description}
                    </div>
                  </div>
                  {formValues?.details?.Content?.ContentMediaType &&
                  formValues?.details?.Content?.ContentValue.length > 0 ? (
                    <div
                      className={
                        PreviewField?.value === "Desktop"
                          ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container
                          : classes.publish__form__main__left__preview__image__mobileHoverDetails__container
                      }
                    >
                      <div
                        className={
                          PreviewField?.value === "Desktop"
                            ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container__title
                            : classes.publish__form__main__left__preview__image__mobileHoverDetails__container__title
                        }
                      >
                        <FormattedMessage id="SOURCE_TYPE_TEXT" /> :
                      </div>
                      <div
                        className={
                          PreviewField?.value === "Desktop"
                            ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container__typeContainer
                            : classes.publish__form__main__left__preview__image__mobileHoverDetails__container__typeContainer
                        }
                      >
                        <div
                          className={
                            PreviewField?.value === "Desktop"
                              ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container__typeContainer__courseType
                              : classes.publish__form__main__left__preview__image__mobileHoverDetails__container__typeContainer__courseType
                          }
                        >
                          {formValues?.details?.Content?.ContentMediaExtension?.toUpperCase() +
                            " " +
                            contentMediaTypes.find(
                              (type) =>
                                type.mediaType ===
                                formValues?.details?.Content?.ContentMediaType,
                            )?.text}
                        </div>
                        <div
                          className={
                            PreviewField?.value === "Desktop"
                              ? classes.publish__form__main__left__preview__image__desktopHoverDetails__container__typeContainer__icon
                              : classes.publish__form__main__left__preview__image__mobileHoverDetails__container__typeContainer__icon
                          }
                          onClick={() => {
                            handlePlayContent();
                          }}
                        >
                          <Tooltip content="Play Content" direction="right">
                            <PlayIcon />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <div
                  className={
                    PreviewField?.value === "Desktop"
                      ? classes.publish__form__main__left__preview__image__desktopPlayIcon
                      : classes.publish__form__main__left__preview__image__mobilePlayIcon
                  }
                >
                  <PlayIcon />
                </div>
              )}
            </div>
          </div>
          <div className={classes.publish__form__main__right}>
            <div className={classes.publish__form__main__right__heading}>
              <FormattedMessage id="SC_SETTINGS_TEXT" />
            </div>
            <div className={classes.publish__form__main__right__fields}>
              {formData.map((field, index) => {
                if (field?.visible) {
                  // Skip CustomizeCompletionScreen field completely for Webinar Training Type classes
                  if (
                    field.type === "custom" &&
                    field.name === "CustomizeCompletionScreen" &&
                    isWebinarSelected
                  ) {
                    return null;
                  }

                  // Handle custom completion screen field
                  if (
                    field.type === "custom" &&
                    field.name === "CustomizeCompletionScreen"
                  ) {
                    return (
                      <div
                        key={`completion-screen-${index}-${field?.key || field?.name}`}
                        className={
                          classes.publish__form__main__right__fields__field
                        }
                      >
                        <div
                          className={
                            classes.publish__completionScreen__fieldContainer
                          }
                        >
                          <Input
                            label={field?.label}
                            name={field?.name}
                            type="checkbox"
                            labelColor={"light"}
                            direction={"row-reverse"}
                            width="2"
                            height="2"
                            disabled={
                              shotclassType === "view" || field?.disabled
                            }
                            checked={isCustomCompletionEnabled}
                            onChange={(e) =>
                              handleCompletionScreenCheckbox(e.target.checked)
                            }
                          />
                          {showViewLink && (
                            <button
                              type="button"
                              onClick={handleViewCompletionScreen}
                              className={
                                classes.publish__completionScreen__viewLink
                              }
                            >
                              View
                            </button>
                          )}
                        </div>
                        <Tooltip
                          content={field?.toolTipText}
                          direction={"bottom"}
                        >
                          <div
                            className={
                              classes.publish__form__main__right__fields__iconSpacing
                            }
                          >
                            <InfromationSmallIcon />
                          </div>
                        </Tooltip>
                      </div>
                    );
                  }

                  // Regular field rendering
                  console.log(`DEBUG: Rendering regular field: ${field.name}`);
                  return (
                    <div
                      key={`field-${index}-${field?.key || field?.name}`}
                      className={
                        classes.publish__form__main__right__fields__field
                      }
                    >
                      <Input
                        label={field?.label}
                        name={field?.name}
                        fieldName={field?.fieldName}
                        fieldValue={field?.fieldValue}
                        type={field?.type || "checkbox"}
                        placeholder={field?.placeholder}
                        labelColor={"light"}
                        direction={"row-reverse"}
                        width={field?.width || "2"}
                        height={field?.height || "2"}
                        disabled={shotclassType === "view" || field?.disabled}
                        searchable={field?.searchable}
                        searchTagsList={field?.searchTagsList}
                        handleTagList={field?.handleTagList}
                        error={errors[field?.name]?.message}
                      />
                      {field?.type !== "noSearchTags" && (
                        <Tooltip
                          content={field?.toolTipText}
                          direction={"bottom"}
                        >
                          <div
                            className={
                              classes.publish__form__main__right__fields__iconSpacing
                            }
                          >
                            <InfromationSmallIcon />
                          </div>
                        </Tooltip>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <React.Fragment
                      key={`fragment-${index}-${field?.key || field?.name}`}
                    ></React.Fragment>
                  );
                }
              })}
            </div>
          </div>
        </div>
        <div className={classes.publish__form__footer}>
          <div
            className={classes.publish__form__footer__backButton}
            onClick={handleBack}
          >
            <PreviousIcon fill={colors.theme} />
            <div
              className={classes.publish__form__footer__backButton__linkMedium}
            >
              {/* {submitButtonText} */}
              Previous
            </div>
          </div>
          <div className={classes.publish__form__footer__submitButton}>
            {shotclassType !== "view" &&
              (shotclassType !== "edit" ||
                (shotclassType === "edit" &&
                  shotclassTypeFrom === "myDrafts")) &&
              !location.pathname.includes(
                moderateContributions.path(tenantName),
              ) && (
                <Button
                  label={<FormattedMessage id="SAVE_CLASS_TEXT" />}
                  small
                  dark
                  onClick={handleSaveAsDraft}
                  loading={saveAsADraftLoader}
                />
              )}
            {shotclassType !== "view" && (
              <Button
                label={<FormattedMessage id="CREATE_PUBLISH_TEXT" />}
                small
                dark
                type="submit"
                //onClick={onSubmit}
                disabled={!isValid && hasRestricted}
                loading={shotclassPublishLoader}
              />
            )}
          </div>
        </div>
      </form>
      <Modal
        handleSubmit={() => {
          submitData(formValues);
          setNoContentModal(!noContentModal);
        }}
        isOpen={noContentModal}
        heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
        toggle={() => setNoContentModal(!noContentModal)}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
        width={"46.2"}
        height={"26.9"}
        loading={shotclassPublishLoader}
      >
        <div className={classes.publish__noContentModal}>
          <div className={classes.publish__noContentModal__text}>
            <FormattedMessage id="CREATE_CLASS_NO_CONTENT_ALERT" />
          </div>
        </div>
      </Modal>

      {/* Completion Screen Customization Modal */}
      <Modal
        isOpen={isCompletionScreenModal}
        heading="Customize Completion Screen"
        toggle={handleCloseCompletionScreenModal}
        buttonLabel1="Save"
        handleSubmit={() =>
          handleCompletionSubmit(handleSaveCompletionScreen)()
        }
        width={"75"}
        height={"auto"}
        submitDisabled={!isCompletionValid}
        isScroll={false}
      >
        <FormProvider {...completionScreenForm}>
          <form onSubmit={handleCompletionSubmit(handleSaveCompletionScreen)}>
            <div className={classes.publish__completionScreen__modalContent}>
              <ShotclassCourseFinished
                completionTitle={completionDefaults.title}
                completionMessage={completionDefaults.message}
                isEditing={true}
                disabled={shotclassType === "view"} // Disable inputs in view mode
                completionErrors={completionErrors}
                completionRegister={completionRegister}
                completionWatch={completionWatch}
                completionControl={completionControl}
              />
            </div>
          </form>
        </FormProvider>
      </Modal>
    </FormProvider>
  );
};

export default Publish;
